import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { ActionsProps } from '@lib/components/ReactHookForm/FormContainer';

interface WidgetTemplateFormActionsProps extends ActionsProps {
  onCancel: () => void;
  isViewOnly?: boolean;
}

export default function WidgetTemplateFormActions({
  onCancel,
  isViewOnly,
  loading,
}: WidgetTemplateFormActionsProps) {
  const { t } = useTranslation();

  if (isViewOnly) {
    return (
      <ActionsRow
        actions={[
          <Button
            key="close"
            buttonText={t('close')}
            buttonType={ButtonTypes.secondaryOutlined}
            onClick={onCancel}
            leftIcon="close"
            disabled={loading}
          />,
        ]}
      />
    );
  }

  return (
    <ActionsRow
      actions={[
        <Button
          key="cancel"
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          onClick={onCancel}
          leftIcon="close"
          fullWidth
          disabled={loading}
        />,
        <Button
          key="save"
          buttonText={t('save')}
          buttonType={ButtonTypes.primaryFilled}
          type="submit"
          leftIcon="check"
          fullWidth
          disabled={loading}
        />,
      ]}
    />
  );
}
